var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"","hover":"","responsive":"","items":_vm.items,"fields":_vm.fields,"current-page":this.currentPage,"per-page":_vm.perPage},scopedSlots:_vm._u([_vm._l((this.extraSlots),function(slot){return {key:slot,fn:function(context){return _c('div',{on:{"click":function($event){$event.stopPropagation();_vm.clicked(context)}}},[_vm._t(slot)],2)}}})])})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c387ae2","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/FITTable.vue
// module id = null
// module chunks = 